import styled from 'styled-components';

import { StyledHeaderButton } from '../MenuManager/Header/HeaderButton/styles';

const Button = styled(StyledHeaderButton)`
	position: relative;
	top: 1px;
	left: 2px;
`;

export {
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ButtonCreateNote/styles.ts